export default __webpack_public_path__ + "img/titan-3.68e58a.svg";